import {ReviewState, ReviewStore} from "./review.interface";
import {CardMarkupViewerState} from "../markup/cardMarkupViewer/cardMarkupViewer.interface";

export const reviewInitialState: ReviewStore = {
    cardId: undefined,
    state: ReviewState.Loading,
    markupState: CardMarkupViewerState.OnlyQuestion,
    isExtraActionsMenuOpen: false,
    cardNumberInReview: 0,
    totalCardsForReview: 0,
    // MultiCard support
    isMultiCard: false,
    selectedSubcards: [],
    currentSubcardIndex: 0,
    isLastSubcard: false,
    showSubcardButtons: false,
    subcardReviewStartTime: undefined,
    subcardTimings: [],
    subcardCorrectness: [],
    // Random subcards tracking
    viewedSubcardIndices: [],
    allSubcards: [],
};
